// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image {\n  height: auto;\n  margin: auto;\n}\n\n.img-wrapper {\n  padding: '15px 15px 0px 15px';\n}\n\n.size-big {\n  width: 100%;\n}\n\n.size-medium {\n  width: 50%;\n}\n\n.size-small {\n  width: 25%;\n}\n\n.align-left {\n  float: left;\n}\n\n.align-right {\n  float: right;\n}\n\n.align-center {\n  margin: 0 auto;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
